export interface LoginFooterData {
  forgotLoginText: string;
  forgotLoginViewName: string;
  forgotPasswordText: string;
  forgotPasswordViewName: string;
  joinSkyMilesLink: string;
  joinSkyMilesText: string;
  forgotLoginLink: string;
  forgotPasswordLink: string;
  accountRecoveryFlowEnabled?: boolean;
  continueAsGuestText?: string;
  shopAsGuestText?: string;
  mfaForgotLoginText?: string;
  logOutAndShopAgainText?: string;
}

export const mockloginFooterData: LoginFooterData = {
  forgotLoginText: 'Logintext',
  forgotLoginViewName: 'loginviewname',
  forgotPasswordText: 'passtext',
  forgotPasswordViewName: 'passwordViewName',
  joinSkyMilesLink: 'https://test.com/joinSkymiles',
  joinSkyMilesText: 'SkymilesText',
  forgotLoginLink: 'https://test.com/login',
  forgotPasswordLink: 'https://test.com/forgotpassword',
  accountRecoveryFlowEnabled: true,
  continueAsGuestText: 'CONTINUE AS GUEST',
  shopAsGuestText: 'SHOP AS GUEST'
};
